export default "__VITE_ASSET__8609bcd0__"